<template>
  <div class="enigma-container">
    <overlay-navigation class="absolute w-full h-full" :hide-info="true" />
    <text-mystery :background-id="'12'" :id="12" />
  </div>
</template>

<script>
import OverlayNavigation from '@/components/OverlayNavigation.vue'
import TextMystery from '@/components/TextMystery.vue'
export default {
  name: 'Enigma12',
  components: {
    OverlayNavigation,
    TextMystery
  },
  mounted() {
    // Trackings
    this.$gtmTracking.pageView()
    this.$mmTro.sendRtg()
  }
}
</script>

<style lang="scss" scoped>
</style>